export default Object.freeze({
  CreditCard: 0,
  Account: 1
});
